import styled, { keyframes } from "styled-components";

const glow = keyframes`
  from {
    text-shadow: 0 0 5x #c22323, 0 0 7px #c22323, 0 0 9px #c22323;
  }
  to {
    text-shadow: 0 0 7px #c22323, 0 0 9px #c22323, 0 0 11px #c22323;
  }
`;

export const LoadingLogo = styled.img`
  color: #d0021b;
  height: 150px;
  animation: ${glow} 1.5s ease-in-out infinite alternate;
`;

export const Title = styled.div`
  font-family: "Cinzel", serif;
  font-size: 3em;
  margin-top: 10px;
  color: #d0021b;
  animation: ${glow} 1.5s ease-in-out infinite alternate;
  text-align: center;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;